import React from "react";
import {Background, ReactFlowProvider} from "reactflow";
import "reactflow/dist/style.css";
import PropTypes from "prop-types";
import {Responsive, WidthProvider} from "react-grid-layout";
/* Styles */
import "./grid-layout.scss";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const GRID_COLUMNS = {lg: 12, md: 1, sm: 1, xs: 1, xxs: 1};
const GRID_BG_CONTAINER = {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "calc(100% - 1.5rem)",
};

class GridLayout extends React.PureComponent {
    render() {
        const isGridEmpty = !this.props.children.length > 0;
        return (
            <ReactFlowProvider attributionPosition="none">
                <div className="glu-grid-layout">
                    <div className="glu-grid-layout-bg-container" style={GRID_BG_CONTAINER}>
                        <Background />
                    </div>

                    {isGridEmpty && (
                        <div className="glu-grid-layout__empty">
                            Drag and drop selected widgets from sidepanel into your new dashboard.
                        </div>
                    )}
                    <ResponsiveReactGridLayout
                        isResizable={this.props.isResizable}
                        droppingItem={this.props.droppingItemSettings}
                        layouts={this.props.layouts}
                        cols={GRID_COLUMNS}
                        onLayoutChange={this.props.onLayoutChange}
                        onDrop={this.props.onDrop}
                        onDragStart={this.onDragStart}
                        measureBeforeMount={false}
                        isDroppable
                        compactType="vertical"
                        draggableHandle=".glu-icon__draggable"
                        rowHeight={126}
                        containerPadding={[0, 20]}
                        style={{minHeight: "100%"}}
                    >
                        {this.props.children}
                    </ResponsiveReactGridLayout>
                </div>
            </ReactFlowProvider>
        );
    }
}

GridLayout.propTypes = {
    children: PropTypes.node,
    isResizable: PropTypes.bool.isRequired,
    onDrop: PropTypes.func,
    droppingItemSettings: PropTypes.objectOf(PropTypes.any).isRequired,
};

GridLayout.defaultProps = {
    children: null,
    onDrop: undefined,
};

export default GridLayout;
